module.exports = __webpack_public_path__ + "img/closeIconGrey.e51cd81a.svg";